import React from 'react';

import { SERVICE_STATUS_HELP } from './EmptyStateHelp';
import type { EmptyStateScreen } from './EmptyStateEvents';
import TrackedEmptyState from './TrackedEmptyState';

export const LOAD_ERROR_BODY = 'Something went wrong on our end. Your data is safe.';
export const TRY_AGAIN_LABEL = 'Try again';

export type WidgetLoadError = { onRetry: () => void };

export const WIDGET_LOAD_ERROR_HEADLINES = {
  chart: "Couldn't load this chart",
  metric: "Couldn't load this metric",
  crawlerRequests: "Couldn't load crawler requests",
} as const;

type LoadErrorEmptyStateProps = {
  screen: EmptyStateScreen;
  headline: string;
  onRetry: () => void;
  detail?: string;
  compact?: boolean;
};

function LoadErrorEmptyState({ screen, headline, onRetry, detail, compact = false }: LoadErrorEmptyStateProps) {
  return (
    <TrackedEmptyState
      screen={screen}
      state="error"
      headline={headline}
      body={LOAD_ERROR_BODY}
      action={{ id: 'try_again', label: TRY_AGAIN_LABEL, destination: 'retry', onClick: onRetry }}
      secondaryAction={compact ? undefined : SERVICE_STATUS_HELP}
      detail={detail}
      compact={compact}
    />
  );
}

export default LoadErrorEmptyState;
